// cleanRenderOptions — the renderOptions part of a Detail Groups field override,
// reduced to the keys that actually change something before it is saved.
//
// Every key is carried through generically — including nested objects such as
// `subFieldFormats` — so a render option added later needs no change here to
// survive a save. Only undefined, '' and false are dropped (an unset switch and
// an unset text box are "no setting", not a setting of their own).
//
// Returns null when nothing is left, so the caller can omit the key entirely.
export function cleanRenderOptions(renderOptions) {
  const out = {};
  for (const [key, value] of Object.entries(renderOptions ?? {})) {
    if (value !== undefined && value !== '' && value !== false) out[key] = value;
  }
  return Object.keys(out).length ? out : null;
}
